import popUpTypes from '@/types/pop-up-types'

export function isItemReturned(item) {
    return item?.status && item.status.toLowerCase() === 'returned'
}

export function isItemUnpaid(item) {
    return (item?.total_paid || 0) === 0
}

export function canReturnItem(item) {
    if (!item) return false
    return !item.closed_at && !isItemReturned(item) && isItemUnpaid(item)
}

export function getItemId(item) {
    if (!item) return null
    return item.id
}

export function filterReturnableItems(items) {
    if (!Array.isArray(items)) return []
    return items.filter((item) => canReturnItem(item))
}

export function createSingleReturnPayload(itemId, comment = null) {
    return {
        shipment_item_id: itemId,
        comment,
    }
}

export function createBulkReturnPayload(items, comment = null) {
    return {
        items: items.map((item) => ({
            shipment_item_id: getItemId(item),
            comment: null,
        })),
        comment,
    }
}

export function handleReturnError(error, showError, defaultErrorKey = 'pages.shipments.returnError') {
    if (error === 'cancelled') return
    
    console.error('Error returning items:', error)
    const errorMessage = error?.response?.data?.message || defaultErrorKey
    showError(errorMessage)
}

export function resetSelection(component) {
    component.selectedItems = []
}

export function handleBulkOperationResponse(response, handlers, operationType = 'close') {
    if (!handlers || !handlers.showSuccess || !handlers.openModal) {
        console.error('handleBulkOperationResponse: handlers are required')
        return
    }

    const data = response?.data || response
    const failedItems = data?.failed_items || 0
    const processedItems = data?.processed_items || 0
    const totalItems = data?.total_items || 0
    const results = data?.results || []

    if (failedItems === 0 && processedItems === totalItems) {
        const messageKey =
            operationType === 'return'
                ? 'pages.shipments.itemsReturned'
                : 'pages.shipments.itemsClosed'
        handlers.showSuccess(messageKey)
        return
    }

    if (failedItems > 0 && results.length > 0) {
        handlers.openModal({
            name: popUpTypes.shipmentBulkOperationResults,
            payload: {
                resultsData: {
                    processed_items: processedItems,
                    failed_items: failedItems,
                    total_items: totalItems,
                    results: results,
                },
            },
        })
        return
    }

    if (processedItems > 0) {
        handlers.showSuccess('pages.shipments.bulkOperationPartialSuccess', {
            processed: processedItems,
            total: totalItems,
        })
    }
}
